export const LPJ_MAX_BYTES = 5 * 1024 * 1024;

export const LPJ_SENSITIVE_CONFIRMATION =
  "Saya sudah memeriksa laporan ini dan memastikan tidak memuat data pribadi yang tidak perlu, seperti nomor identitas, nomor rekening, atau nomor telepon peserta.";

export type LpjStatus =
  | "TIDAK_DIWAJIBKAN"
  | "BELUM_DIUNGGAH"
  | "SUDAH_TERSEDIA"
  | "DIARSIPKAN"
  | null;

export type LpjStatusItem = {
  activityUuid: string;
  slug: string;
  lpjStatus: LpjStatus;
  canUploadLpj: boolean;
};

const STATUS_LABELS: Record<Exclude<LpjStatus, null>, string> = {
  TIDAK_DIWAJIBKAN: "Tidak diwajibkan",
  BELUM_DIUNGGAH: "Belum diunggah",
  SUDAH_TERSEDIA: "Sudah tersedia",
  DIARSIPKAN: "Diarsipkan",
};

export const lpjStatusLabel = (status: LpjStatus): string =>
  status === null ? "Menunggu aktivitas selesai" : STATUS_LABELS[status];

export const isValidLpjPdf = async (
  file: File | undefined,
): Promise<boolean> => {
  if (!file || file.size > LPJ_MAX_BYTES) return false;
  if (
    file.type !== "application/pdf" ||
    !file.name.toLowerCase().endsWith(".pdf")
  )
    return false;
  const bytes = new Uint8Array(await file.slice(0, 5).arrayBuffer());
  return String.fromCharCode(...bytes) === "%PDF-";
};

export const safeLpjError = (status: number | undefined): string => {
  const messages: Record<number, string> = {
    401: "Sesi berakhir. Silakan masuk kembali.",
    403: "Anda tidak memiliki akses untuk tindakan ini.",
    404: "Laporan belum tersedia.",
    413: "Ukuran file melebihi batas 5 MiB.",
    429: "Terlalu banyak percobaan. Silakan coba lagi.",
  };
  return (
    (status !== undefined && messages[status]) ||
    "LPJ belum dapat dimuat. Silakan coba lagi."
  );
};
